import axios from "axios";

const URL = process.env.REACT_APP_OPEN_WETHEAR_URL;
const API_KEY = process.env.REACT_APP_OPEN_WETHEAR_API_KEY;

export const fetchWeather = async (query) => {
  return await axios.get(URL, {
    params: {
      q: query,
      units: "metric",
      appid: API_KEY,
      lang: "fr",
    },
  });
};
